import React, { ReactElement } from 'react';
import { actions as elearningCommentsActions } from '@/modules/reducers/comments';

import AddReviewerButton from '../AddReviewerButton';
import ReviewersListView from './ReviewersListView';
import { useDispatch } from 'react-redux';
import ReviewerComments from '../Comments';
import { ReviewerType } from '@/modules/types/reviewers';
import {
  useDeleteReviewerMutation,
  useSendReminderMutation,
} from '@/modules/services/reviewers';
import { actions as flashMessageActions } from '@/modules/reducers/flashMessage';

const ReviewersList = ({
  ReviewersListData,
}: {
  ReviewersListData: ReviewerType[];
}): ReactElement => {
  const dispatch = useDispatch();

  const [sendReminder] = useSendReminderMutation();
  const [deleteReviewer] = useDeleteReviewerMutation();

  const handleViewComments = (
    reviewerIndex: number,
    reviewers: { id: string }[],
  ) => {
    if (reviewers) {
      dispatch({
        type: elearningCommentsActions.openCommentsModal.type,
        payload: { reviewerId: reviewers[reviewerIndex].id },
      });
    }
  };

  const handleSendReminder = async (reviewerId: string) => {
    await sendReminder(reviewerId);
    dispatch({
      type: flashMessageActions.addFlashMessage,
      payload: {
        isActive: true,
        message: 'Reminder sent',
      },
    });
  };

  const handleDeleteReviewer = async (reviewerId: string) => {
    await deleteReviewer(reviewerId);
    dispatch({
      type: flashMessageActions.addFlashMessage,
      payload: {
        isActive: true,
        message: 'Reviewer deleted',
      },
    });
  };

  return (
    <>
      <AddReviewerButton />

      <ReviewersListView
        reviewers={ReviewersListData}
        onViewComments={handleViewComments}
        onSendReminder={handleSendReminder}
        onDeleteReviewer={handleDeleteReviewer}
      />

      <ReviewerComments />
    </>
  );
};

export default ReviewersList;
